<template>
  <div class="assistance">
    <div class="assistance__heading">
      Hulp nodig tijdens bestellen?
    </div>

    <p class="assistance__description">
      Kunnen wij je ergens mee helpen? Onze klantenservice is van maandag t/m vrijdag (9:00 tot 17:00 uur)
      bereikbaar op <a href="tel:0166619100">0166-619100</a>
      of mail naar <a href="mailto:klantenservice@poortvliet.nl">klantenservice@poortvliet.nl</a>.
    </p>
  </div>
</template>

<style>
@import url("~layers/app/components/Checkout/Assistance.css");
</style>
